import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { AgGridReact } from 'ag-grid-react';
import { InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import unshareProjectButton from './unshareProject';
import ProjectContext from '../../context/ProjectContext';
import { AvatarImage } from '../Avatar';

const propTypes = {
  openToggle: PropTypes.bool.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

const UserAvatar = (params) => {
  const { data } = params;

  return (
    <div className="user-avatar">
      <AvatarImage borderGray name={data.userName} alt={data.userName} fontSize={15} height={35} width={35} initials={2} src={data.logo} />
    </div>
  );
};

const UserNameAndEmail = (params) => {
  const { data } = params;

  return (
    <div className="user-name-and-email">
      <span>{data.userName}</span>
      <span className="email">{data.emailAddress}</span>
    </div>
  );
};

const UnshareProject = ({ openToggle, handleCloseDialog }) => {
  const { usersOfProjects } = React.useContext(ProjectContext);

  const modalTitle = 'Users List';

  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState();

  const getSharedData = async () => {
    const sharedData =
      usersOfProjects && usersOfProjects
        .filter((projectItem) => parseInt(projectItem.workspaceProfileId, 10) !== parseInt(projectItem.projectCreatedBy, 10))
        .map((row) => ({ id: row.id, logo: row.logo, userName: row.userName, projectName: row.projectName, emailAddress: row.emailAddress }));
    setRowData(sharedData);
  };

  useEffect(() => {
    getSharedData();
    return () => {
      setRowData([]);
    };
  }, []);

  const onFilterTextBoxChanged = (e) => {
    const dataFilter = e.target.value;
    gridApi.setQuickFilter(dataFilter);
  };

  const defaultColDef = useMemo(() => ({ resizable: true }), []);

  const columnDefs = [
    {
      headerName: 'Image',
      field: 'image',
      cellRenderer: UserAvatar,
      flex: 1,
      cellStyle: {
        border: 'none',
        justifyContent: 'start',
      },
      cellRendererParams: (option) => option.data,
    },
    {
      headerName: 'User Name',
      flex: 9,
      field: 'userName',
      cellRenderer: UserNameAndEmail,
      cellStyle: {
        border: 'none',
        paddingLeft: 10,
        justifyContent: 'start',
      },
    },
    {
      headerName: 'Remove Button',
      flex: 3,
      type: 'rightAligned',
      field: 'removeButton',
      cellRenderer: unshareProjectButton,
      cellStyle: {
        border: 'none',
        justifyContent: 'end',
      },
    },
  ];
  return (
    <form action="/project">
      <Dialog
        className="custom-modal-dialog user-list-modal-dialog"
        fullWidth
        open={openToggle}
        onClose={handleCloseDialog}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <div className="unshare-project-title">
            <h4>{modalTitle}</h4>
            <div style={{ width: '50%' }}>
              <div style={{ width: '100%' }}>
                <TextField
                  className="search-input unshare-dialog-search-input"
                  type="search"
                  placeholder="Search people in project"
                  onChange={onFilterTextBoxChanged}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" style={{ color: 'rgba(0, 0, 0, 0.4)' }}>
                        <SearchIcon className="search-icon" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="ag-theme-alpine" style={{ minHeight: '15vh' }}>
            {(!rowData.length || (gridApi && !(gridApi.getRenderedNodes().length))) && <div className="no-data-found">No data found</div>}
            <AgGridReact
              className="ag-theme-custom-react user-list-table"
              gridOptions={{
                suppressNoRowsOverlay: true,
                rowHeight: 60,
                headerHeight: 0,
                defaultColDef: {
                  resizable: false,
                },
              }}
              rowData={rowData}
              columnDefs={columnDefs}
              domLayout="print"
              onGridReady={(gridParams) => {
                setGridApi(gridParams.api);
              }}
              defaultColDef={defaultColDef}
            />
          </div>
        </DialogContent>
      </Dialog>
    </form>
  );
};
UnshareProject.propTypes = propTypes;
export default UnshareProject;
